import React from 'react';
import MedicalHistoryConfigForm, {
	MedicalHistoryConfigFormValues,
} from './MedicalHistoryConfigForm';
import useLoading from '../../../../../Base/Hooks/useLoading';
import useApiClient from '../../../../../Base/Hooks/useApiClient';
import { useCreateMedicalHistoryTypeMutation } from '../../../../../../graphql/graphql';
import { slugify } from '../../../../../Base/Helpers/slug.helper';

interface Props {
	onCreate: () => void;
}

const MedicalHistoryConfigCreate: React.FC<Props> = ({ onCreate }) => {
	const { isLoading, setIsLoading, RenderLoading } = useLoading();
	const { displayGQLError, displayError } = useApiClient();
	const [createMedicalHistoryType] = useCreateMedicalHistoryTypeMutation();

	const handleSubmit = async (values: MedicalHistoryConfigFormValues) => {
		setIsLoading(true);
		try {
			const response = await createMedicalHistoryType({
				input: { name: values.name, value: slugify(values.name), active: true },
			});
			displayGQLError(response);

			if ('data' in response) {
				onCreate();
			}
		} catch (e) {
			displayError(e);
		}
		setIsLoading(false);
	};

	if (isLoading) {
		return <RenderLoading />;
	}

	return (
		<MedicalHistoryConfigForm
			onSubmit={handleSubmit}
			submitText='base.create'
		/>
	);
};

export default MedicalHistoryConfigCreate;
